module.exports = __webpack_public_path__ + "img/no-data.d6e17003.svg";